import React, { useState } from "react";

const ExpertModalCart = ({ item, expertId, setExpertItem }) => {
  const selectExpertClickHandler = () => {
    if (item?.expert_report_code) {
      setExpertItem(item);
    }
  };

  return (
    <li
      className={"flex items-center justify-between gap-2 mb-6"}
      onClick={selectExpertClickHandler}
    >
      <div className={"flex items-center gap-2"}>
        <div
          className={`border border-stone-400 ${expertId === item.id ? "bg-orange-500" : "bg-white"} bg- w-5 h-5 rounded-[4px] flex items-center justify-center`}
        >
          {expertId === item.id && (
            <span className={"mt-1 ml-[2px] text-white"}>✔</span>
          )}
        </div>
        <span className={`${item?.expert_report_code ? "" : "text-stone-500"}`}>
          {item?.full_name ? item?.full_name : item?.mobile}
        </span>
      </div>
      {item?.expert_report_code ? (
        <span>{item?.expert_report_code}</span>
      ) : (
        <span className={"text-stone-500"}>در حال کارشناسی</span>
      )}
    </li>
  );
};

export default ExpertModalCart;
